import $ from '@vaersaagod/tools/Dom';
import Dispatch from '@vaersaagod/tools/Dispatch';
import Viewport from '@vaersaagod/tools/Viewport';
import * as Events from '../lib/events';

export default el => {
    const dom = $(el);
    const button = dom.find('[aria-expanded]');
    const box = dom.find('[hidden]');
    let active = false;

    const open = () => {
        if (!active) {
            active = true;
            document.addEventListener('keyup', keyHandler);
            button.attr('aria-expanded', true).attr('aria-label', button.data('close'));
            box.attr('hidden', null);
            Viewport.lockTabbing(el);
        }
    };

    const close = () => {
        if (active) {
            active = false;
            document.removeEventListener('keyup', keyHandler);
            button.attr('aria-expanded', false).attr('aria-label', button.data('label'));
            box.attr('hidden', '');
            Viewport.releaseTabbing();
        }
    };

    const toggle = () => {
        Dispatch.emit(button.attr('aria-expanded') === 'false' ? Events.STICKIES_OPEN : Events.STICKIES_CLOSE, dom);
    };

    const keyHandler = e => {
        const key = e.keyCode || e.which;
        if (active && key === 27) {
            Dispatch.emit(Events.STICKIES_CLOSE, dom);
        }
    };

    const init = () => {
        Dispatch.on(Events.STICKIES_OPEN, open);
        Dispatch.on(Events.STICKIES_CLOSE, close);
        button.data('label', button.attr('aria-label'));
        button.on('click', toggle);
        TweenLite.set(button.nodes, { scale: 0.5 });
        TweenLite.to(button.nodes, 0.15, { delay: 1.15, autoAlpha: 1, ease: Circ.easeOut });
        TweenLite.to(button.nodes, 0.35, { delay: 1.15, scale: 1, ease: Back.easeOut });
    };

    const destroy = () => {
        Dispatch.off(Events.STICKIES_OPEN, open);
        Dispatch.off(Events.STICKIES_CLOSE, close);
        button.off('click', toggle);
        document.removeEventListener('keyup', keyHandler);
    };

    return {
        init,
        destroy
    };
};



// WEBPACK FOOTER //
// ./src/js/components/Stickies.js